import { create } from "zustand";
import { createTheme, deleteTheme, retrieveThemes, updateDefaultTheme, updateTheme } from "./actions";
import { ThemeData } from "./data";
import useUXStore from "../../ux/store";

type ThemeStoreProps = {
    loading       :boolean
    themes        :ThemeData[] | null
    defaultTheme  :number
    setDefaultTheme: (index:number) => void
    retrieveThemes: () => void
    updateTheme: (theme:ThemeData) => void 
    deleteTheme: (id:string) => void
    createTheme: (theme:ThemeData) => Promise<string>
    error         :string
}

export const useThemeStore = create<ThemeStoreProps>( (set, getState) => ({
    loading: false,
    themes: null,
    defaultTheme: 0,
    error: "",
    setDefaultTheme(index) {
        set( state => ({defaultTheme:index}))
        updateDefaultTheme(getState().themes![index].Id!)
            .then( () => {})
            .catch( err => set(state => ({error:"Failed to default theme."})))
    },
    retrieveThemes() {
        //console.log("Retrieve themes")
        set( state => ({loading: true}))
        retrieveThemes()
            .then((themes) => {
                const defaultTheme = themes.Themes?.findIndex( item => item.Id === themes.Default)
                set( _ => ({loading:false, themes:themes.Themes, defaultTheme:defaultTheme}))
            })
            .catch((err) => set( _ => ({loading:false, error:err})))
    },
    updateTheme(theme) {
        updateTheme(theme)
            .then( res => {
                getState().retrieveThemes()
            })
        
    },
    deleteTheme(id) {
        deleteTheme(id)
        .then( res => {
            getState().retrieveThemes()
        })
    },
    async createTheme(theme) {
        try {
            //console.log("Creating theme with data:", theme);
            let id = await createTheme(theme)
            getState().retrieveThemes()
            return id
        } catch (error: any) {
            const errorMessage = error?.message || "Found issue while creating theme";
            set( state => ({error: errorMessage}))
            useUXStore.getState().addToast("Theme Creation Failed", errorMessage);
        }
        return ""
    },
}))